import React from 'react';
import { Route } from 'react-router-dom';
import Shopping from './index';

export default <Route path="/homepage/shopping/:id" component={Shopping} />;
